import { PFlexItem, PSpinner, PText } from '@porsche-design-system/components-react'
import React from 'react'

export default function ContentLoading() {
  return (
    <React.Fragment>
      <PFlexItem>
        <PSpinner size='medium' />
      </PFlexItem>
      <PFlexItem>
        <PText align='center'>
          Applikationen <br />
          werden geladen
        </PText>
      </PFlexItem>
    </React.Fragment>
  )
}
